"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdatedDocument = function UpdatedDocument(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 5.5H8C7.93433 5.49995 7.86929 5.51285 7.8086 5.53796C7.74792 5.56307 7.69278 5.5999 7.64634 5.64634C7.5999 5.69278 7.56307 5.74792 7.53796 5.8086C7.51285 5.86929 7.49995 5.93433 7.5 6V18C7.5 18.1326 7.55268 18.2598 7.64645 18.3536C7.74021 18.4473 7.86739 18.5 8 18.5H16C16.1326 18.5 16.2598 18.4473 16.3536 18.3536C16.4473 18.2598 16.5 18.1326 16.5 18V6C16.5 5.86739 16.4473 5.74021 16.3536 5.64645C16.2598 5.55268 16.1326 5.5 16 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17 16.5H15.2744L15.8872 15.8872C15.8887 15.8857 15.8902 15.8841 15.8917 15.8826L15.8981 15.8762C15.8988 15.8755 15.8994 15.8747 15.9 15.8741C16.9254 14.8456 17.5009 13.4523 17.5 12C17.5 8.96728 15.0327 6.5 12 6.5C11.8674 6.5 11.7402 6.55268 11.6464 6.64645C11.5527 6.74021 11.5 6.86739 11.5 7C11.5 7.13261 11.5527 7.25979 11.6464 7.35355C11.7402 7.44732 11.8674 7.5 12 7.5C14.4813 7.5 16.5 9.51869 16.5 12C16.5007 13.1861 16.0316 14.3243 15.1952 15.1654C15.1939 15.1667 15.1925 15.1678 15.1911 15.1691L14.5 15.8602V14C14.5 13.8674 14.4473 13.7402 14.3536 13.6464C14.2598 13.5527 14.1326 13.5 14 13.5C13.8674 13.5 13.7402 13.5527 13.6464 13.6464C13.5527 13.7402 13.5 13.8674 13.5 14V17C13.5 17.1326 13.5527 17.2598 13.6464 17.3536C13.7402 17.4473 13.8674 17.5 14 17.5H17C17.1326 17.5 17.2598 17.4473 17.3536 17.3536C17.4473 17.2598 17.5 17.1326 17.5 17C17.5 16.8674 17.4473 16.7402 17.3536 16.6464C17.2598 16.5527 17.1326 16.5 17 16.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 16.5C9.5187 16.5 7.5 14.4813 7.5 12C7.49928 10.8139 7.96839 9.67579 8.8047 8.83469C8.80606 8.83336 8.80747 8.83222 8.80892 8.83089L9.5 8.13978V10C9.5 10.1326 9.55268 10.2598 9.64645 10.3536C9.74022 10.4473 9.86739 10.5 10 10.5C10.1326 10.5 10.2598 10.4473 10.3536 10.3536C10.4473 10.2598 10.5 10.1326 10.5 10V7C10.5 6.86739 10.4473 6.74021 10.3536 6.64645C10.2598 6.55268 10.1326 6.5 10 6.5H7C6.86739 6.5 6.74022 6.55268 6.64645 6.64645C6.55268 6.74021 6.5 6.86739 6.5 7C6.5 7.13261 6.55268 7.25979 6.64645 7.35355C6.74022 7.44732 6.86739 7.5 7 7.5H8.72556L8.11278 8.11278C8.11158 8.11394 8.11045 8.11519 8.10925 8.11636L8.10183 8.12381C8.10106 8.12456 8.10042 8.12542 8.09967 8.12619C7.07444 9.15464 6.49913 10.5478 6.5 12C6.5 15.0327 8.96728 17.5 12 17.5C12.1326 17.5 12.2598 17.4473 12.3536 17.3536C12.4473 17.2598 12.5 17.1326 12.5 17C12.5 16.8674 12.4473 16.7402 12.3536 16.6464C12.2598 16.5527 12.1326 16.5 12 16.5Z",
    fill: props.foregroundColor
  }));
};

UpdatedDocument.defaultProps = {
  altText: "Updated Document",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
UpdatedDocument.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = UpdatedDocument;
exports.default = _default;